import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { AuthStateContext } from "./AuthContext";

const ProtectedRoute = () => {
  const location = useLocation();
  const { checked, authenticated } = useContext(AuthStateContext);

  if (!checked) return null;
  if (!authenticated) return <Navigate to="/" state={{ from: location }} replace />;

  return <Outlet />;
};

export default ProtectedRoute;
